export default "__VITE_ASSET__BLSpYnN5__"